import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import ApiService from "../../core/service/api-service";
import {Button, Col, Divider, Form, Input, List, message, Row, Select, Typography} from "antd";
import ModalitySelectBox from "../modality/ModalitySelectBox";
import Flex from "../../core/components/Flex";
import {EditOutlined, SearchOutlined} from "@ant-design/icons";
import {useModal} from "../../core/context/ModalContext";
import RequestTypeGroupCreateEdit from "./RequestTypeGroupCreateEdit";
import {toast} from "react-toastify";
import RequestTypeCreateEdit from "./RequestTypeCreateEdit";

export default function RequestTypeManage()
{
    const {t} = useTranslation();
    const {openModal, closeModal} = useModal()

    const [selectedModalityId, setSelectedModalityId] = useState(null);
    const [requestTypes, setRequestTypes] = useState([])
    const [selectedRequestTypeId, setSelectedRequestTypeId] = useState(null);
    const [searchText, setSearchText] = useState('');

    const normalizeText = (text) => {
        return text
            .toLowerCase()
            .replace(/ç/g, 'c')
            .replace(/ğ/g, 'g')
            .replace(/ı/g, 'i')
            .replace(/ö/g, 'o')
            .replace(/ş/g, 's')
            .replace(/ü/g, 'u');
    };

    const filteredRequestTypes = requestTypes.filter(requestType => {
        if (!searchText) return true;
        const normalizedSearch = normalizeText(searchText);
        return (
            normalizeText(requestType.displayName || '').includes(normalizedSearch) ||
            normalizeText(requestType.name || '').includes(normalizedSearch) ||
            normalizeText(requestType.sutCode || '').includes(normalizedSearch) ||
            normalizeText(requestType.loincCode || '').includes(normalizedSearch)
        );
    }).sort((a, b) => (a.name || '').localeCompare(b.name || ''));

    const getRequestTypes = async () => {
        if(selectedModalityId && selectedModalityId > 0)
        {
            const response = await ApiService.RequestType.GetByModality(selectedModalityId)
            if(response.success)
            {
                setRequestTypes(response.data)
            }
        }
    }

    useEffect(() => {
        getRequestTypes()
    }, [selectedModalityId])


    const editRequestType = async (requestType) => {
        if(!selectedModalityId)
        {
            toast.error(t('Please Select Modality'))
            return
        }

        openModal(t(!requestType.id ? 'New Request Type' : 'Edit Request Type - ' + requestType.name), (
            <RequestTypeCreateEdit
                modalityId={selectedModalityId}
                requestType={requestType}
                onSaved={() => {
                    closeModal()
                    getRequestTypes()
                }}
            />
        ))
    }

    return (
        <>
            <Form
                layout={'vertical'}
            >
                <Form.Item
                    label={t('Modality')}
                >
                    <ModalitySelectBox
                        onChange={(e) => {
                            setSelectedModalityId(e);
                            setSelectedRequestTypeId(null)
                            setRequestTypes([])
                            setSearchText('')
                        }}
                        mode={'single'}
                    />
                </Form.Item>

                <Form.Item
                    label={t('Search')}
                >
                    <Input
                        placeholder={t('Search by name, display name, SUT code, LOINC code')}
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        disabled={!selectedModalityId}
                    />
                </Form.Item>

                <Form.Item
                >
                    <Row gutter={24}>
                        <Col xs={24}>
                            <div
                                id="scrollableDiv"
                                style={{
                                    height: 600,
                                    overflow: 'auto',
                                    padding: '0 16px',
                                    border: '1px solid rgba(140, 140, 140, 0.35)',
                                }}
                            >
                                <List
                                    header={(
                                        <Typography.Title level={5}>
                                            {t('Requests')}
                                            <Button
                                                onClick={() => {editRequestType({})}}
                                                style={{marginLeft: 8}}
                                            >
                                                {t('Add')}
                                            </Button>
                                        </Typography.Title>
                                    )}
                                    dataSource={filteredRequestTypes}
                                    renderItem={(item) => {
                                        return (
                                            <List.Item>
                                                <Typography.Text>
                                                    {item.name} - (SUT: {item.sutCode}, LOINC: {item.loincCode})
                                                </Typography.Text>
                                                <Button
                                                    onClick={() => {editRequestType(item)}}
                                                    style={{marginLeft: 8}}
                                                    type={'text'}
                                                >
                                                    <EditOutlined />
                                                </Button>
                                            </List.Item>
                                        )
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </>
    )
}
